import { Component, OnInit, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'booking-history',
  templateUrl: './booking-history.component.html',
  styleUrls: ['./booking-history.component.css']
})
export class BookingHistoryComponent implements OnInit {


  currOrganization: any;
  loggedInUser: any;
  showDiffList: any = false;

  constructor(
    private activeModal: NgbActiveModal
  ) {
    if (window.localStorage.getItem('currentUser')) {
      this.loggedInUser = JSON.parse(window.localStorage.getItem('currentUser'));
      console.log("kbskcdkfkdhiu", this.loggedInUser);
      
    }
    if (window.localStorage.getItem('currOrganization')) {
      this.currOrganization = JSON.parse(window.localStorage.getItem('currOrganization'));
    }
  }

  @Input() data: any;

  ngOnInit() {
    this.processBreadCrumbLinks();
  }

  private processBreadCrumbLinks() {
    console.log('history ', this.data);
  }

  closeModal() {
    this.activeModal.dismiss();
  }

  checkVisibility(history: any) {
    return history && history.showFor && history.showFor.length && history.showFor.includes(this.loggedInUser.roleValue)
  }

  getHistoryTitle(history:any){
    let title = history.title
    let userRoleValue =  this.loggedInUser.roleValue
    if(userRoleValue == '5672'){
      title = history.empTitle || history.title
    } else if(userRoleValue == '9918') {
      title = history.tdTitle || history.title
    }
    else if(userRoleValue == '2236') {
      title = history.hotelTitle || history.title
    }
    else if(userRoleValue == '3421') {
      title = history.aprTitel || history.title
    }
    return title;
  }

  viewDiffList(history: any) {
    console.log(history.diffList)
    this.showDiffList = true;
    console.log('am in viewDiffList ', history, this.showDiffList);
    let tableHead = "<br/><br/><table  border='1' style='background-color: #fff; overflow-x: auto; color:black;border-collapse: collapse;width: 100%;'><tr style='background:#1a73e8;color:#fff'>" +
      "<th>Field Name</th><th>Original Value</th><th>Amended Value</th>" +
      "</tr>";
    let tableRow = "";
    let all = history.diffList;
    for (var i = 0; i < all.length; i++) {
      let odd = 'padding: 8px;background-color: #fff;'
      let even = 'padding: 8px;background-color: #f2f2f2;'
      let isCheckOut = all[i].key.includes('_checkOut_');
      let isCheckIn = all[i].key.includes('_checkIn_');
      let isDates = ''
      if(isCheckOut) {
        isDates = '(Check-Out)'
      } else if(isCheckIn) {
        isDates = '(Check-in)'
      }

      let rowStyle = ((i % 2) == 0 ? even : odd);
      tableRow += "<tr style=" + rowStyle + ">"
      tableRow += "<td>" + all[i].name + "<br/>" + isDates + "</td><td>" + all[i].oldVal + "</td></td>" +
        "<td>" + all[i]['newVal'] + "</td></tr>";
    }
    let body = "</table>";
    body += tableHead;
    body += tableRow;

    Swal.fire({
      title: '<strong>Employee updated the request</strong>',
      width: 600,
      // icon: 'info',
      html: body,
      showCloseButton: true,

    })
  }

  getRowClass(data: any) {
    let res = '';
    if (data.title && data.title.includes('Rejected')) {
      res = 'cls-danger'
    } else if (data.title && data.title.includes('Confirmed')) {
      res = 'cls-success'
    } else if (data.title && data.title.includes('paid')) {
      res = 'cls-success'
    }
    if (data.createdBy.organization.toLowerCase() == 'hotel') {
      if (data.createdBy.uid != this.currOrganization.tenantId) {
        res = 'hide-me'
      }
    }
    return res;
  }

}
